<template lang="pug">
v-app
  template(v-if="!loading")
    main-header(v-if="$route.path !== '/error404'")
    v-main
      router-view
    main-footer(v-if="$route.path !== '/error404'")
    whatsapp-button(:tel="tel")
    v-btn.fab-facebook(
      :href="informations.facebook",
      color="#2374e1",
      target="_blank",
      fab
    )
      v-icon(color="white") fab fa-facebook-f
    v-btn.fab-instagram(
      :href="informations.instagram",
      color="#E1306C",
      target="_blank",
      fab
    )
      v-icon(color="white") fab fa-instagram
  v-sheet.d-flex.justify-center.align-center(
    v-else,
    height="100%",
    width="100%",
    color="transparent"
  )
    v-progress-circular(:size="50", color="primary", indeterminate)
  cookie-banner
</template>

<script>
import WhatsappButton from "@/components/buttons/WhatsappButton";
import MainHeader from "@/components/shell/main-header/Index.vue";
import MainFooter from "@/components/shell/MainFooter.vue";
import CookieBanner from "@/components/widgets/CookieBanner.vue";

export default {
  data: () => ({
    loading: true,
  }),
  computed: {
    branches() {
      return this.$rest("branches").list;
    },
    tel() {
      return this.branches.map(({ title, whatsapp }) => ({
        name: title,
        tel: whatsapp ? whatsapp.replace(/[^0-9]/g, "") : "",
      }));
    },
    informations() {
      return this.$rest("informations").item;
    },
    name() {
      return this.informations.name || "";
    },
  },
  watch: {
    name() {
      document.title = `${this.$route.name} - ${this.name}`;
    },
    $route() {
      document.title = `${this.$route.name} - ${this.name}`;
    },
  },
  created() {
    document.title = `${this.$route.name} - ${this.name}`;
  },
  beforeCreate() {
    this.$rest("informations")
      .get({
        save: (state, data) => (state.item = data),
      })
      .then(() => (this.loading = false));

    this.$rest("branches").get();
  },
  components: {
    MainHeader,
    MainFooter,
    WhatsappButton,
    CookieBanner,
  },
};
</script>

<style>
.h-100 {
  height: 100% !important;
}
.w-100 {
  width: 100% !important;
}
.relative {
  position: relative;
}
.absolute {
  position: absolute;
}
.cursor-pointer {
  cursor: pointer;
}
.filter-opacity {
  filter: opacity(0.6);
}

.opacity-0 {
  opacity: 0;
}

.fade-in {
  animation: fade-in 1.2s cubic-bezier(0.39, 0.575, 0.565, 1) both;
}
@keyframes fade-in {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
.world-break-all {
  word-break: break-all;
}

.fab-facebook,
.fab-instagram {
  position: fixed;
  right: 16px;
  z-index: 999;
}

.fab-facebook {
  bottom: 148px;
}

.fab-instagram {
  bottom: 80px;
}
</style>
